export enum QuestContractReadFunctionNames {
  GET_USER_INFO = 'getUserInfo', // return points
}
export enum QuestContractWriteFunctionNames {
  RUN_DAILY_QUEST = 'runDailyQuest', // run daily quest
  MINT = 'mintNft', // mint NFT from points
  FORGE = 'forge', // ment next level NFT from existed NFTS
}

export enum Tiers {
  BronzeRock = 1, // - 1 - Entry level, basic performance
  BronzePaper = 2, // - 2 - Entry level, basic performance
  BronzeScissors = 3, // - 3 - Entry level, basic performance

  SilverRock = 4, // - 4 - Beginner mastery, noticeable improvement
  SilverPaper = 5, // - 5 - Beginner mastery, noticeable improvement
  SilverScissors = 6, // - 6 - Beginner mastery, noticeable improvement

  GoldRock = 7, // - 7 - Competent and reliable performance
  GoldPaper = 8, // - 8 - Competent and reliable performance
  GoldScissors = 9, // - 9 - Competent and reliable performance

  PlatinumRock = 10, // - 10 - Advanced skill, consistent high play
  PlatinumPaper = 11, // - 11 - Advanced skill, consistent high play
  PlatinumScissors = 12, // - 12 - Advanced skill, consistent high play

  DiamondRock = 13, // - 13 - Expert level, top-tier competence
  DiamondPaper = 14, // - 14 - Expert level, top-tier competence
  DiamondScissors = 15, // - 15 - Expert level, top-tier competence

  MasterRock = 16, // - 16 - Elite class, refined and strategic performance
  MasterPaper = 17, // - 17 - Elite class, refined and strategic performance
  MasterScissors = 18, // - 18 - Elite class, refined and strategic performance

  GrandmasterRock = 19, // - 19 - Pinnacle tier, reserved for the absolute best
  GrandmasterPaper = 20, // - 20 - Pinnacle tier, reserved for the absolute best
  GrandmasterScissors = 21, // - 21 - Pinnacle tier, reserved for the absolute best
}
